<p-dialog
    header=" "
    [(visible)]="displayModal"
    [modal]="true"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }"
    [dismissableMask]="true"
    appendTo="body"
>
    <div class="picture-div">
        <img [src]="pictureAccessLink" class="picture" />
    </div>
</p-dialog>
